module.exports = __webpack_public_path__ + "img/quickly-identify.d23b6739.png";